<template>
  <div @click.stop="() => {}">
    <el-row>
      <l-table
        class="l-table-layout"
        :isShowNum="false"
        :highlightCurrentRow="false"
        :stripe="false"
        :isRowHover="false"
        :showOverflow="false"
        :isColumnResizable="false"
        isNotMinWidth
        isColumnHover
        borderType="none"
        height="notset"
        :columns="columns"
        :dataSource="rows"
        :cellStyle="cellStyle"
        :headerCellStyle="headerCellStyle"
        :mergeCells="mergeCells"
        :minHeight="0"
        headerCellClassName="l-drag-table-header-cell"
        @headerClick="headerClick"
        @cellClick="cellClick"
      >
        <template v-for="(col, index) in columns" v-slot:[col.prop]="scope">
          <div
            :class="[
              'l-rblock',
              'l-drag-table-cell',
              {
                'cell-active':
                  selectWidget.prop == `${myId}.${col.prop}.${scope.$rowIndex}` ||  selectWidget.prop == `${myId}.${col.prop}` ,
              },
            ]"
            :style="{
              height: `${getCell(col.prop, scope.$rowIndex).height}px`,
            }"
            :key="index"
          >
            <drag-form-wraper
              ref="dragFormWraper"
              :parentType="myComponent.type"
              :select.sync="selectWidget"
              :componentsList="childrenComponents(col.prop, scope.$rowIndex)"
              :plist="parentComponents"
            />
            <div v-if="selectWidget.prop == `${myId}.${col.prop}.${scope.$rowIndex}`" class="l-table-layout-td">
              <el-dropdown
                size="mini"
                trigger="click"
                @command="handleTdCommand"
              >
                <i class="el-icon-setting"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in getTdBtns()"
                    :key="item.prop"
                    :command="{
                      colIndex: scope.$columnIndex,
                      rowIndex: scope.$rowIndex,
                      type: item.prop,
                    }"
                    :disabled="item.disabled"
                    :divided="item.divided"
                  >
                    {{ $t(item.label) }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </template>
      </l-table>
    </el-row>
    <el-tooltip :content="$t('添加行')" placement="top" :enterable="false">
      <el-button
        @click.stop="handleAddRow()"
        class="drag-table-action-addrow"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="success"
      >
        <i class="learun-icon-add"></i>
      </el-button>
    </el-tooltip>
    <el-tooltip :content="$t('添加列')" placement="top" :enterable="false">
      <el-button
        @click.stop="handleAddCol()"
        class="drag-table-action-addcol"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="success"
      >
        <i class="learun-icon-add"></i>
      </el-button>
    </el-tooltip>

    <el-button
      :title="$t('复制')"
      @click.stop="handleWidgetClone(index)"
      class="drag-table-action-clone"
      v-if="selectWidget.prop == myComponent.prop"
      circle
      plain
      size="mini"
      type="primary"
    >
      <i class="el-icon-copy-document"></i>
    </el-button>
    <el-button
      :title="$t('删除')"
      @click.stop="handleWidgetDelete(index)"
      class="drag-table-action-delete"
      v-if="selectWidget.prop == myComponent.prop"
      circle
      plain
      size="mini"
      type="danger"
    >
      <i class="el-icon-delete"></i>
    </el-button>
  </div>
</template>
<script>
import mixin from "./mixin";
export default {
  name: "drag-form-tablelayout",
  mixins: [mixin()],
  data() {
    return {};
  },
  computed: {
    myId(){
      return this.myComponent.prop;
    },
    columns() {
      return this.myComponent.cols.map((t) => ({ isNotAutoWrap: false, ...t }));
    },
    rows() {
      const rows = [];
      let { cells } = this.myComponent;
      for (let cell of cells) {
        let row = rows[cell.rowIndex];
        if (!row) {
          row = {};
          rows[cell.rowIndex] = row;
        }
        row[cell.colId] = "";
      }
      return rows;
    },
    maxRowIndex() {
      let { cells } = this.myComponent;
      let maxRowIndex = 0;
      for (let cell of cells) {
        if (cell.rowIndex > maxRowIndex) {
          maxRowIndex = cell.rowIndex;
        }
      }
      return maxRowIndex;
    },

    cellStyle(){
      let res = {cursor: 'auto', height: '1px'};
      if(this.myComponent.borderWidth == 0){
        res.border = `1px dashed ${this.myComponent.borderColor}`
      }
      else{
        res.border = `1px solid ${this.myComponent.borderColor}`
      }
     
      return res
    },
    mergeCells(){
      let { cells,cols } = this.myComponent;
      let res = [];
      for (let cell of cells) {
        if(cell.rowspan > 1 || cell.colspan >1){
          let col = cols.findIndex(t=>t.prop == cell.colId);
          res.push({
            rowspan: cell.rowspan,
            colspan: cell.colspan,
            row: cell.rowIndex,
            col: col
          })
        }
      }
      return res
    }
  },
  methods: {
    handleWidgetClone(index) {
      let cloneData = this.$deepClone(this.myComponent);
      cloneData.prop = Date.now() + "_" + Math.ceil(Math.random() * 99999);
      this.setAllProp(cloneData.cells, true);
      this.parentComponents.splice(index, 0, cloneData);
      this.$nextTick(() => {
        this.handleSelectWidget(index + 1);
        this.$emit("change");
      });
    },
    handleFormClickAdd(item) {
      if (this.tabActive) {
        this.childrenComponents.push(item);
        this.$refs.dragFormWraper[parseInt(this.tabActive)].handleFormAdd(
          { newIndex: this.childrenComponents.length - 1 },
          true
        );
      } else {
        return false;
      }
    },

    getCell(colId, rowIndex) {
      let { cells } = this.myComponent;
      return cells.find((t) => t.colId == colId && t.rowIndex == rowIndex) || {};
    },
    childrenComponents(colId, rowIndex) {
      return this.getCell(colId, rowIndex).children || [];
    },

    headerClick(data) {
      this.selectWidget = {
        type: "tableLayoutTh",
        prop: this.myId +"."+ this.myComponent.cols[data.$columnIndex].prop,
        column: this.myComponent.cols[data.$columnIndex],
      };
    },
    headerCellStyle({column}){
      if(column.field == `${this.myId}.${this.selectWidget.prop}` ){
        return {'background-color': '#e6f7ff'}
      }
      return {}
    },

    getNextCol(colIndex,rowIndex,colspan){
      let { cells,cols } = this.myComponent;
      let nextCol = cols[colIndex+ colspan]
      let nextCellId = nextCol.prop
      let nextCellIndex = cells.findIndex(item => item.colId == nextCellId && item.rowIndex == rowIndex);
      let nextCell = cells[nextCellIndex]

      return {nextCell,nextCellIndex};
    },
    getNextRow(colId,rowIndex,rowspan){
      let { cells } = this.myComponent;

      let nextCellIndex = cells.findIndex(item =>item.colId == colId && item.rowIndex == rowIndex+rowspan)
      let nextCell = cells[nextCellIndex]

      return {nextCell,nextCellIndex};
    },

    getRowIndex(colId,rowIndex,isNotFirst){
      let { cells } = this.myComponent;
      let res = cells.findIndex(item =>item.colId == colId && item.rowIndex == rowIndex)
      if(res == -1 && rowIndex <= this.maxRowIndex){
        if(isNotFirst){
          return this.getRowIndex(colId,rowIndex + 1,true);
        }

        // 如果等于-1需要判断该单元格是被垂直合并了
        let topIndex = cells.findIndex(item =>item.colId == colId && item.rowIndex == rowIndex-2)// 中间空一行所以要减2
        if(topIndex != -1 && cells[topIndex].rowspan == 1){
          if(rowIndex < this.maxRowIndex){
            let bottomIndex = cells.findIndex(item =>item.colId == colId && item.rowIndex == rowIndex+1)
            if(bottomIndex != -1){
              return rowIndex - 1;
            }
          }
          else{
            return rowIndex - 1;
          }
        }

        return this.getRowIndex(colId,rowIndex + 1,true);
      }
      return rowIndex - 1;
    },
    getColId(colIndex,rowIndex,colId,isNotFirst){
      let { cells,cols } = this.myComponent;
      if(colIndex == undefined || cols.length == colIndex){
        return colId;
      }
      let myColId = cols[colIndex].prop;
      let res = cells.findIndex(item =>item.colId == myColId && item.rowIndex == rowIndex)
      if(res == -1){
        if(!isNotFirst){
          // 如果等于-1需要判断该单元格是被垂直合并了
          let leftColId = cols[colIndex-1].prop;
          let leftIndex = cells.findIndex(item =>item.colId == leftColId && item.rowIndex == rowIndex)
          if(leftIndex != -1 && cells[leftIndex].colspan == 1){
            if(colIndex < cols.length - 1){
              let rightColId = cols[colIndex+1].prop;
              let rightIndex = cells.findIndex(item =>item.colId == rightColId && item.rowIndex == rowIndex)
              if(rightIndex != -1){
                return colId;
              }
            }
            else{
              return colId;
            }
          }

        }
        return this.getColId(colIndex + 1,rowIndex,myColId,true);
      }
      return colId;
    },

    handleAddRow(index) {
      let { cells, cols } = this.myComponent;
      let maxRowIndex = this.maxRowIndex;
      if(index != undefined){
        maxRowIndex = index;

        for(let cell of cells){
          if(cell.rowIndex >= maxRowIndex){
            cell.rowIndex++;
          }
        }
      }
      else{
        maxRowIndex++;
      }

      let addCells = [];
      for (let col of cols) {
        let rowIndex = maxRowIndex;
        if(index != undefined && rowIndex < this.maxRowIndex){
          rowIndex = this.getRowIndex(col.prop,rowIndex+1);
        }

        addCells.push({
          colId: col.prop,
          rowIndex: rowIndex,
          rowspan: 1,
          colspan: 1,
          children: [],
        });
      }

      cells.push(...addCells);
    },
    handleAddCol(index) {
      let { cells, cols } = this.myComponent;
      let maxRowIndex = this.maxRowIndex;
      let addCells = [];
      let col = {
        prop: Date.now() + "_" + Math.ceil(Math.random() * 99999),
      };
      for (let i = 0; i <= maxRowIndex; i++) {
        addCells.push({
          colId:this.getColId(index,i,col.prop),
          rowIndex: i,
          rowspan: 1, 
          colspan: 1,
          children: [],
        });
      }
      cells.push(...addCells);
      if(index != undefined){
        cols.splice(index,0,col);
      }
      else{
        cols.push(col);
      }
    },
    handleDeleteCol(index){
      let { cells,cols } = this.myComponent;
      let col = cols[index];
      let _cells = []
      for(let cell of cells){
        if(cell.colId != col.prop){
          let cellColIndex = cols.findIndex((item) => item.prop == cell.colId);
          if(index > cellColIndex && index < cellColIndex + cell.colspan){
            cell.colspan--;
          }
          _cells.push(cell)
          
        }
        else if(cell.colspan > 1){
          cell.colId = cols[index+1].prop;
          cell.colspan--;
          _cells.push(cell)
        }
      }

      cols.splice(index,1);
      this.myComponent.cells = _cells;
    },
    handleDeleteRow(index){
      let { cells } = this.myComponent;
      let _cells = []
      for(let cell of cells){
        if(cell.rowIndex != index){
          _cells.push(cell)
          if(cell.rowIndex > index){
            cell.rowIndex--;
          }
        }
      }

      this.myComponent.cells = _cells;
    },

    handleMergeCol(){
      let {cell,colIndex} = this.selectWidget;
      let { cells,cols } = this.myComponent;
      let {nextCell,nextCellIndex} = this.getNextCol(colIndex,cell.rowIndex,cell.colspan);
      let nextColIndex = colIndex+cell.colspan

      cell.children.push(...nextCell.children)
      cell.colspan += nextCell.colspan;
      cells.splice(nextCellIndex,1)

      // 如果当前列找不到一个单元格，此列取消
      if(nextCell.colspan == 1 && cells.findIndex(t=>t.colId == nextCell.colId) == -1){
        let mergeCells = cells.filter(t=>t.colId == cell.colId)
        for(let mergeCell of mergeCells){
          mergeCell.colspan--;
        }
        cols.splice(nextColIndex,1);
      }
    },
    handleMergeRow(){
      let { cells } = this.myComponent;
      let {cell} = this.selectWidget;
      let {nextCell,nextCellIndex} = this.getNextRow(cell.colId,cell.rowIndex,cell.rowspan);

      cell.children.push(...nextCell.children)
      cell.rowspan += nextCell.rowspan;
      cells.splice(nextCellIndex,1)

      // 如果当前行找不到一个单元格，此行取消
      if(nextCell.rowspan == 1 && cells.findIndex(t=>t.rowIndex == nextCell.rowIndex) == -1){
        for(let cellItem of cells){
          if(cellItem.rowIndex == cell.rowIndex){
            cellItem.rowspan--;
          }
          else if(cellItem.rowIndex > cell.rowIndex)
          {
            cellItem.rowIndex--;
          }
        }
      }
    },
    handleSplitCol(){
      let { cells,cols } = this.myComponent;
      let {cell,colIndex} = this.selectWidget;
      let addCells =[]
      for (let i = 1; i < cell.colspan; i++) {
        addCells.push({
          colId: cols[colIndex+i].prop,
          rowIndex: cell.rowIndex,
          rowspan: cell.rowspan, 
          colspan: 1,
          children: [],
        });
      }
      cell.colspan = 1;
      cells.push(...addCells)
    },
    handleSplitRow(){
      let { cells } = this.myComponent;
      let {cell,rowIndex} = this.selectWidget;
      let addCells =[]
      for (let i = 1; i < cell.rowspan; i++) {
        addCells.push({
          colId: cell.colId,
          rowIndex: rowIndex+i,
          rowspan: 1,
          colspan: cell.colspan,
          children: [],
        });
      }
      cell.rowspan = 1;
      cells.push(...addCells)
    },

    cellClick(data) {
      let {cells,cols} = this.myComponent;
      let colId = cols[data.$columnIndex].prop;
      let rowIndex = data.$rowIndex;
      let id = this.myId;
      this.selectWidget = {
        type: "tableLayoutTd",
        prop:id + "." + cols[data.$columnIndex].prop + "." + rowIndex,
        cell: cells.find(
          (t) => t.colId == colId && t.rowIndex == rowIndex
        ),
        colIndex:data.$columnIndex,
        rowIndex:rowIndex
      };
    },
    handleTdCommand(
      command
    ) {
      switch(command.type){
        case "insert—left":
          this.handleAddCol(command.colIndex);
          break;
        case "insert—right":
          this.handleAddCol(command.colIndex + this.selectWidget.cell.colspan);
          break;
        case "insert—top":
          this.handleAddRow(command.rowIndex);
          break;
        case "insert—bottom":
          this.handleAddRow(command.rowIndex +  this.selectWidget.cell.rowspan);
          break;
        case "delete-col":
          this.handleDeleteCol(command.colIndex);
          this.selectWidget = this.myComponent;
          break;
        case "delete-row":
          this.handleDeleteRow(command.rowIndex);
          this.selectWidget = this.myComponent;
          break;
        case "merge-col":
          this.handleMergeCol();
          break;
        case "merge-row":
          this.handleMergeRow();
          break;
        case "split-col":
          this.handleSplitCol();
          break;
        case "split-row":
          this.handleSplitRow();
          break;
      }
    },
    getTdBtns() {
      let {cell,colIndex,rowIndex} =  this.selectWidget;
      let btns = [
        {
          prop: "insert—left",
          label: "左插入列",
        },
        {
          prop: "insert—right",
          label: "右插入列",
        },
        {
          prop: "insert—top",
          label: "上插入行",
        },
        {
          prop: "insert—bottom",
          label: "下插入行",
        }
      ];
      // 合并
      let mergeColBtn =  {
        prop: "merge-col",
        label: "向右合并",
        divided:true
      }
      if(colIndex + cell.colspan == this.myComponent.cols.length){
        mergeColBtn.disabled = true;
      }
      else{
        let {nextCell} = this.getNextCol(colIndex,cell.rowIndex,cell.colspan);
        if(!nextCell || nextCell.rowspan != cell.rowspan){
          mergeColBtn.disabled = true;
        }
      }
      btns.push(mergeColBtn);
      let mergeRowBtn =  {
        prop: "merge-row",
        label: "向下合并",
      }

      if(rowIndex + cell.rowspan - 1 == this.maxRowIndex){
        mergeRowBtn.disabled = true;
      }
      else{
        let {nextCell} = this.getNextRow(cell.colId,cell.rowIndex,cell.rowspan);
        if(!nextCell || nextCell.colspan != cell.colspan){
          mergeRowBtn.disabled = true;
        }

      }
      btns.push(mergeRowBtn);
      // 拆分
      let splitColBtn =  {
        prop: "split-col",
        label: "拆分成列",
        divided:true,
        disabled:cell.colspan > 1?false:true,
      };
      btns.push(splitColBtn);

      let splitRowBtn =  {
        prop: "split-row",
        label: "拆分成行",
        disabled:cell.rowspan > 1?false:true,
      };
      btns.push(splitRowBtn);

      // 删除
      let deleteColBtn =  {
        prop: "delete-col",
        label: "删除当前列",
        divided:true
      };
      if(this.myComponent.cols.length == 1 || cell.colspan > 1){
        deleteColBtn.disabled = true;
      }
      btns.push(deleteColBtn);

      let deleteRowBtn =  {
        prop: "delete-row",
        label: "删除当前行",
      };
      if(this.maxRowIndex == 0){
        deleteRowBtn.disabled = true;
      }
      btns.push(deleteRowBtn);

      return btns;
    },
  },
};
</script>
